module.exports = __webpack_public_path__ + "static/media/health-international-main-icon.120568ac.svg";